import IndustryRegulations from './IndustryRegulations'

export default IndustryRegulations